export const service = [
    {
        discription: "Lorem ipsum felis consur adipiscing elit. Nunc condimentum felis tellus pretium voluptatum.",
        image: "assets/img/services/1.png",
        title: "Optimization"
    },
    {
        image: "assets/img/services/2.png",
        title: "Market Analysis",
        discription: "Lorem ipsum felis consur adipiscing elit. Nunc condimentum felis tellus pretium voluptatum.",

    },
    {
        discription: "Lorem ipsum felis consur adipiscing elit. Nunc condimentum felis tellus pretium voluptatum.",
        image: "assets/img/services/3.png",
        title: "Concept & Idea"
    },
    {
        discription: "Lorem ipsum felis consur adipiscing elit. Nunc condimentum felis tellus pretium voluptatum.",
        image: "assets/img/services/4.png",
        title: "Development"
    },
    {
        discription: "Lorem ipsum felis consur adipiscing elit. Nunc condimentum felis tellus pretium voluptatum.",
        image: "assets/img/services/5.png",
        title: "Integration"
    },
    {
        discription: "Lorem ipsum felis consur adipiscing elit. Nunc condimentum felis tellus pretium voluptatum.",
        image: "assets/img/services/6.png",
        title: "Support"
    },
    {
        discription: "Lorem ipsum felis consur adipiscing elit. Nunc condimentum felis tellus pretium voluptatum.",
        image: "assets/img/services/7.png",
        title: "Money back"
    },
    {
        discription: "Lorem ipsum felis consur adipiscing elit. Nunc condimentum felis tellus pretium voluptatum.",
        image: "assets/img/services/8.png",
        title: "Safe Delivery"
    },
]
